export enum ReservationMode {
  Outward = 'Outward',
  Return = 'Return',
};
